/** @format */

import React, {FunctionComponent, useEffect, useState} from 'react';
import {TableBody, TableHead} from '@material-ui/core';
import PlatformMsisdnPoolNumber from '../../../interfaces/platform/PlatformMsisdnPoolNumber';
import TableRow from '@material-ui/core/TableRow';
import Order from '../../../interfaces/forms/Order';
import Filter from '../../../interfaces/forms/Filter';
import TableHeaderContentCell from '../../../components/Table/TableHeaderContentCell';
import TableCell from '@material-ui/core/TableCell';
import I18n from '../../../components/Translate/I18n';
import ViewButton from '../../../components/Buttons/ViewButton';
import {MsisdnStateHelper, numberStateIdMapInt} from '../../lib/search/MsisdnStateHelper';
import {IccidMvnoStatusHelper, iccidMvnoStatusI18n, iccidMvnoStatusIdInt} from '../../lib/search/IccidMvnoStatusHelper';
import { DateHelperTs } from '../../../helpers/DateHelperTs';
import { IndicatedRangeLoader } from '../../../modules/indicated-range/IndicatedRangeLoader';
import { msisdnStatus } from '../../../helpers/msisdnStatus';
import OPL_STYLE from '../../../assets/themes/OPL/OplStyle';
import {HeaderCheckBoxSelectListElement} from "../../lib/search/listTableHeader/HeaderCheckBoxSelectList";

export type StorageMsisdnSuperUserViewType = {
    classes: any;
    poolItems: Array<PlatformMsisdnPoolNumber> | null;
    viewCallback: (iri: { uri: string }, event: any) => void;
    firstLoad: () => void;
    setActiveRow: (id: number) => void;
    activeRow: number;
    updateOrderList: (orders: Array<Order>) => void;
    updateFilterList: (filters: Array<Filter>) => void;
    filters: Array<Filter>;
    orders: Array<Order>;
    iccidStatusHelper: IccidMvnoStatusHelper;
    indicatedRangeLoader: IndicatedRangeLoader;
};

export const StorageMsisdnPartnerView: FunctionComponent<StorageMsisdnSuperUserViewType> = ({
    poolItems,
    classes,
    viewCallback,
    updateOrderList,
    updateFilterList,
    setActiveRow,
    activeRow,
    firstLoad,
    filters,
    orders,
    iccidStatusHelper,
    indicatedRangeLoader,
}): React.ReactElement => {
    const tableStickyHeader = {root: classes.tableStickyHeader};
    const tableControlStickyHeader = {root: classes.tableControlStickyHeader};
    const tableStickyCommand = {root: classes.tableStickyCommand};
    const tableCellRoot = {root: classes.tableCellRootBordered};
    const tableRowRoot = {root: classes.tableRowRoot};
    const [msisdnStatusList, setMsisdnStatusList] = useState<Array<HeaderCheckBoxSelectListElement> | null>(null);
    const getMvnoStatus = (status: number, numberState: number): string | null => {
        if (numberState !== numberStateIdMapInt.USED && status === iccidMvnoStatusIdInt.NOT_SET) {
            return '';
        }
        if (status === iccidMvnoStatusIdInt.NOT_SET) {
            return iccidMvnoStatusI18n.NOT_SET;
        }
        return iccidStatusHelper.getName(status);
    };

    const getStatus = (status: number): string => msisdnStatus(status);
    useEffect(() => {
        if (!msisdnStatusList) {
            const statusHelper = new MsisdnStateHelper();
            const msisdnStatusesList = statusHelper.getStatusListM();
            setMsisdnStatusList(msisdnStatusesList);
        }
    }, [msisdnStatusList]);
    return (
        <React.Fragment>
            <TableHead>
                <TableRow>
                    <TableCell classes={tableStickyCommand} padding="none" align="left">
                        <TableHeaderContentCell textAlign="left" title="general:common.commands" onlyFilter={true}/>
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="simcard:list.msisdn"
                            fieldName="msisdn"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="number"
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            title="pools:msisdn.number_state"
                            textAlign="left"
                            fieldName="numberState"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="select"
                            selectComponent="headerCheckBoxSimpleList"
                            elementList={msisdnStatusList}
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    {/*<TableCell classes={tableStickyHeader} padding="none" align="left">*/}
                    {/*    <TableHeaderContentCell*/}
                    {/*        textAlign="left"*/}
                    {/*        title="simcard:list.status_mvno"*/}
                    {/*        fieldName="mvnoStatus"*/}
                    {/*        showSort={true}*/}
                    {/*        onlyFilter={false}*/}
                    {/*        defaultDirection="desc"*/}
                    {/*        searchFieldType="select"*/}
                    {/*        selectComponent="headerCheckBoxSimpleList"*/}
                    {/*        elementList={iccidStatusHelper.getListToStorage()}*/}
                    {/*        filters={filters}*/}
                    {/*        sort={orders}*/}
                    {/*        updateOrderList={updateOrderList}*/}
                    {/*        updateFilterList={updateFilterList}*/}
                    {/*        searchActionCallback={firstLoad}*/}
                    {/*    />*/}
                    {/*</TableCell>*/}
                    {/*<TableCell classes={tableStickyHeader} padding="none" align="left">*/}
                    {/*    <TableHeaderContentCell*/}
                    {/*        textAlign="left"*/}
                    {/*        title="simcard:list.mvno_status_date"*/}
                    {/*        fieldName="mvnoStatusDate"*/}
                    {/*        showSort={true}*/}
                    {/*        onlyFilter={false}*/}
                    {/*        defaultDirection="asc"*/}
                    {/*        searchFieldType="date"*/}
                    {/*        dateFormat="RRRR-MM-DD"*/}
                    {/*        dateFromTo={true}*/}
                    {/*        filters={filters}*/}
                    {/*        sort={orders}*/}
                    {/*        breakLine={true}*/}
                    {/*        updateOrderList={updateOrderList}*/}
                    {/*        updateFilterList={updateFilterList}*/}
                    {/*        searchActionCallback={firstLoad}*/}
                    {/*        nullable={true}*/}
                    {/*    />*/}
                    {/*</TableCell>*/}
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            textAlign="left"
                            title="simcard:list.activate_count"
                            fieldName="activationCount"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="number"
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            title="simcard:list.portin_date"
                            textAlign="left"
                            fieldName="portinDate"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="asc"
                            searchFieldType="date"
                            dateFormat="RRRR-MM-DD"
                            dateFromTo={true}
                            filters={filters}
                            sort={orders}
                            breakLine={true}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                            nullable={true}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left">
                        <TableHeaderContentCell
                            title="simcard:list.indicated_range"
                            textAlign="left"
                            fieldName="indicatedRangeId"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="select"
                            selectComponent="headerCheckBoxSimpleList"
                            elementList={indicatedRangeLoader.getHeaderList()}
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {poolItems?.map((item) => {
                    const statusString = getMvnoStatus(item.mvnoStatus, item.numberState);
                    let rowActiveColor = 'white';
                    if (activeRow === item.id) {
                        rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
                    }
                    return (
                        <TableRow
                            classes={tableRowRoot}
                            key={'key' + item.id}
                            hover
                            onClick={(): void => {
                                setActiveRow(item.id);
                            }}
                            style={{ backgroundColor: rowActiveColor }}
                        >
                            <TableCell classes={tableControlStickyHeader} padding="none" align="left">
                                <ViewButton
                                    callback={viewCallback}
                                    callbackParam={{ uri: item['@id'] }}
                                    tooltipTitle="pools:add.msisdn_view"
                                    tooltipPlacement="bottom-start"
                                />
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.msisdn}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {<I18n trans={getStatus(item.numberState)} />}
                            </TableCell>
                            {/*<TableCell classes={tableCellRoot} padding="none" align="left">*/}
                            {/*    {statusString && <I18n trans={statusString} />}*/}
                            {/*</TableCell>*/}
                            {/*<TableCell classes={tableCellRoot} padding="none" align="left">*/}
                            {/*    {item.mvnoStatusDate && DateHelper.format(item.mvnoStatusDate)}*/}
                            {/*</TableCell>*/}
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.activationCount}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {item.portinDate && DateHelperTs.format(item.portinDate, 'YYYY-MM-DD')}
                            </TableCell>
                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                {indicatedRangeLoader.getName(item.indicatedRangeId)}
                            </TableCell>
                        </TableRow>
                    );
                })}
            </TableBody>
        </React.Fragment>
    );
};
